// This file can be replaced during build by using the `fileReplacements` array.
// When building for production, this file is replaced with `environment.prod.ts`.

export const environment = {
  production: false,
  PUBLIC_URL: process.env.PUBLIC_URL,
  REACT_APP_BASENAME: process.env.REACT_APP_BASENAME,
  REACT_APP_TITLE: process.env.REACT_APP_TITLE || 'DEV',
  REACT_APP_BASE_URL: process.env.REACT_APP_BASE_URL,
  REACT_APP_GRAPHQL_WS: process.env.REACT_APP_GRAPHQL_WS,

  REACT_APP_CLEVERTAP_KEY: process.env.REACT_APP_CLEVERTAP_KEY,
  REACT_APP_AGORA_APPID: process.env.REACT_APP_AGORA_APPID,

  REACT_APP_firebaseUrl: process.env.REACT_APP_firebaseUrl,
  firebase: {
    appId: process.env.REACT_APP_FIREBASE_appId,
    apiKey: process.env.REACT_APP_FIREBASE_apiKey,
    projectId: process.env.REACT_APP_FIREBASE_projectId,
    authDomain: process.env.REACT_APP_FIREBASE_authDomain,
    storageBucket: process.env.REACT_APP_FIREBASE_storageBucket,
    messagingSenderId: process.env.REACT_APP_FIREBASE_messagingSenderId,
    measurementId: process.env.REACT_APP_FIREBASE_measurementId,
  },
};
